// extracted by mini-css-extract-plugin
export default {"footer":"Footer__footer--LxN"};